// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tVmP","linksContainer":"styles_linksContainer__3_DH2","terms":"styles_terms__1S1so","blueLink":"styles_blueLink__2Jsnx","noLink":"styles_noLink__2N_Ny"};